module.exports = __webpack_public_path__ + "static/media/party-popper.956fce6c.svg";